// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3mZdP","overflowing":"ReadFullNote_overflowing__3hMfm"};